function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { TimedCache } from '../../../utils/timed-cache/timed-cache';
var OVP_LICENSE_TIMEOUT_S = 60 * 4;
var CACHE_CLEAN_INTERVAL_S = 60;
var DEFAULT_CACHE_CAPACITY = 1;
export var SessionControllerPrecursorCache = /*#__PURE__*/ function() {
    "use strict";
    function SessionControllerPrecursorCache() {
        _class_call_check(this, SessionControllerPrecursorCache);
    }
    _create_class(SessionControllerPrecursorCache, null, [
        {
            key: "configure",
            value: function configure(config) {
                this.config = config;
            }
        },
        {
            key: "getInstance",
            value: function getInstance() {
                if (!SessionControllerPrecursorCache.cache) {
                    var _this_config, _this_config1;
                    var capacity = ((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.cacheCapacity) || DEFAULT_CACHE_CAPACITY;
                    var timeout = Math.min(OVP_LICENSE_TIMEOUT_S, ((_this_config1 = this.config) === null || _this_config1 === void 0 ? void 0 : _this_config1.cacheTimeout) || OVP_LICENSE_TIMEOUT_S);
                    var destroyHandler = function(precursor) {
                        return precursor.destroy();
                    };
                    SessionControllerPrecursorCache.cache = new TimedCache(timeout, CACHE_CLEAN_INTERVAL_S, destroyHandler, capacity);
                }
                return SessionControllerPrecursorCache.cache;
            }
        }
    ]);
    return SessionControllerPrecursorCache;
}();
_define_property(SessionControllerPrecursorCache, "cache", null);
_define_property(SessionControllerPrecursorCache, "config", void 0);

//# sourceMappingURL=session-controller-precursor-cache.js.map